const prefix = '@banner';

export const FETCH_BANNERS_REQUEST = `${prefix}/FETCH_BANNERS_REQUEST`;
export const FETCH_BANNERS_SUCCESS = `${prefix}/FETCH_BANNERS_SUCCESS`;
export const FETCH_BANNERS_FAILURE = `${prefix}/FETCH_BANNERS_FAILURE`;
